import { TableBody, TableBodyProps } from "@mui/material";
import { forwardRef } from "react";

export type SHTableBodyProps = TableBodyProps;
export const SHTableBody = forwardRef(
  (props: SHTableBodyProps, ref: any): JSX.Element => (
    <TableBody {...props} ref={ref} />
  ),
);
